import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addActivityCode from './component/addActivityCode.vue';
import addStudent from './component/addStudent.vue';
import parameterPopup from "@/components/parameterPopup/parameterPopup";
import { pageSize } from '@/mixins/index';
export default {
  name: "userList",
  components: {
    addActivityCode: addActivityCode,
    parameterPopup: parameterPopup,
    addStudent: addStudent
  },
  mixins: [pageSize],
  data: function data() {
    return {
      value2: [],
      paramsData: {
        page: 1,
        page_size: 10,
        vip_level: '',
        VIP: '',
        start_time: '',
        end_time: ''
      },
      tableData: [],
      total: 0,
      statusList: [{
        label: '激活',
        value: 1
      }, {
        label: '未激活',
        value: 2
      }],
      giftList: [],
      divisionNewist: []
    };
  },
  created: function created() {
    this.getList();
    this.getGiftLevelList();
    this.getDicisionList();
  },
  methods: {
    datechange: function datechange() {
      if (this.value2 && this.value2.length > 0) {
        this.paramsData.start_time = this.value2[0];
        this.paramsData.end_time = this.value2[1];
      } else {
        this.paramsData.start_time = '';
        this.paramsData.end_time = '';
      }
    },
    getDicisionList: function getDicisionList() {
      var _this = this;

      this.$api.divisionList({
        page_size: -1
      }).then(function (res) {
        if (res.code == 200) {
          _this.divisionNewist = res.data;
        }
      });
    },
    getDivisionNames: function getDivisionNames(divisions) {
      var _this2 = this;

      if (!Array.isArray(divisions) || !divisions.length) return '-';
      return divisions.map(function (id) {
        var match = _this2.divisionNewist.find(function (item) {
          return String(item.id) === String(id);
        });

        return match ? match.name : null;
      }).filter(Boolean).join('、');
    },
    getList: function getList() {
      var _arguments = arguments,
          _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var page;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
                _this3.paramsData.page = page;

                _this3.$api.studentList(_objectSpread(_objectSpread({}, _this3.paramsData), {}, {
                  appid: process.env.VUE_APP_APPID
                })).then(function (res) {
                  if (res.code == 200) {
                    var data = res.data.data;
                    data.forEach(function (item) {
                      if (Array.isArray(item.vip)) {
                        item.vip.forEach(function (vipItem) {
                          vipItem.params = {
                            '是否过期': vipItem.is_vip == 0 ? '已过期' : '未过期',
                            '礼包码等级': vipItem.level_name,
                            '礼包码生效时间': vipItem.start_period_time,
                            '礼包码生效到期时间': vipItem.end_period_time
                          };
                        });
                      }
                    }); // data.forEach(item => {
                    //   if(item.vip){
                    //     let VIPData = JSON.parse(item.vip)
                    //     item.params = {
                    //       '是否过期':VIPData.is_vip == 0 ? '已过期': '未过期',
                    //       '礼包码等级':VIPData.level_name, 
                    //       '礼包码生效时间':VIPData.start_period_time,
                    //       '礼包码生效到期时间':VIPData.end_period_time
                    //     }
                    //     item.is_vip = VIPData.is_vip
                    //   }
                    // })

                    _this3.tableData = data;
                    _this3.total = res.data.total;
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getGiftLevelList: function getGiftLevelList() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.$api.giftCodeLevelList().then(function (res) {
                  if (res.code == 200) {
                    _this4.giftList = res.data;
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handleDelete: function handleDelete(row) {
      var _this5 = this;

      this.$confirm("此操作将删除该学生, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.$api.delStudent({
                  student_id: row.id,
                  appid: process.env.VUE_APP_APPID,
                  account: row.account
                }).then(function (res) {
                  if (res.code == 200) {
                    _this5.$message.success("删除成功!");

                    _this5.getList(_this5.paramsData.page);
                  } else {
                    _this5.$message.error(res.msg);
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    },
    exportDataFn: function exportDataFn() {
      var _this6 = this;

      this.columns = [{
        label: '账号',
        prop: 'account'
      }, {
        label: '名称',
        prop: 'name'
      }, {
        label: '电话',
        prop: 'phone'
      }, {
        label: '学校',
        prop: 'school'
      }, {
        label: '身份证号',
        prop: 'id_card'
      }, {
        label: 'vip',
        prop: 'vipList'
      }, {
        label: '状态',
        prop: 'status_name'
      }];
      this.$api.studentList(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        appid: process.env.VUE_APP_APPID,
        page_size: -1
      })).then(function (res) {
        if (res.code == 200) {
          var data = res.data;
          data.forEach(function (item) {
            item.status_name = item.status == 1 ? '启用' : '禁用';
            item.vipList = item.vip.map(function (itemp) {
              return itemp.code;
            }).join(",");
          });

          _this6.$export.excel({
            columns: _this6.columns,
            data: data,
            title: '用户列表'
          });
        }
      });
    }
  }
};